/** ========================================================================= *\
 * @prefab Markers
 * ========================================================================== */
import { drawRectWithBorder } from 'utils/draw';
import * as CONST from 'config';

class Markers extends Phaser.Group {

  /** @constructor */
  constructor(game, opts) {
    super(game);

    // Draw marker container
    const containerGraphic = new Phaser.Graphics(game);
    containerGraphic.beginFill(0x575756);
    containerGraphic.drawRect(0, 0, opts.containerSize.w, opts.containerSize.h);
    containerGraphic.endFill();
    const containerSprite = new Phaser.Sprite(
      game, opts.containerPos.x, opts.containerPos.y, containerGraphic.generateTexture()
    );
    containerSprite.fixedToCamera = true;
    this.add(containerSprite);
  }

}

export default Markers;


// WEBPACK FOOTER //
// ./js/prefabs/markers.js